(function(){
'use strict';
if(window.PGUKExtrasStatusV146Installed)return;
window.PGUKExtrasStatusV146Installed=true;
var cache=null,fetchSequence=0;
function root(){var value=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';return value.slice(-1)==='/'?value:value+'/'}
function priceAndInput(card){return card?{price:card.querySelector('.pg-extras__price'),input:card.querySelector('.pg-extras__check'),description:card.querySelector('.pg-extras__desc')}:null}
function apply(c){
if(!c||!['GBP','USD'].includes(c.currency))return;
var isUS=c.currency==='USD',tier=isUS?9800:7500,pri=isUS?'+$12':'+£7.99',dig=isUS?'+$15':'+£9.99',combo=isUS?'+$53':'+£22',ex=isUS?'$25':'£14.99';
var engine=window.PGRewardEngineV101;
var amount=engine&&typeof engine.qualifyingSpend==='function'?engine.qualifyingSpend(c):0;
var qualified=Number.isSafeInteger(amount)&&amount>=tier;
var priority=document.querySelector('[data-pg-extras] [data-pg-extra-variant="49189465850108"]');
if(priority){
var parts=priceAndInput(priority.closest('.pg-extras__card'));
if(parts&&parts.input){
parts.input.disabled=qualified;
if(qualified)parts.input.checked=false;
if(parts.price)parts.price.textContent=qualified?'FREE':pri;
var card=priority.closest('.pg-extras__card');
card.classList.toggle('pg-extras__card--included-v146',qualified);
card.setAttribute('aria-label',qualified?'First in Line Artwork included free with qualifying physical spend':'First in Line Artwork, optional '+pri);
var badge=card.querySelector('.pg-extras__included-v146');
if(qualified&&!badge){badge=document.createElement('span');badge.className='pg-extras__included-v146';badge.setAttribute('aria-label','Included with this basket');badge.textContent='✓ Included';card.appendChild(badge)}
if(!qualified&&badge)badge.remove();
}}
var combined=document.querySelector('[data-pg-combined-priority-v149]');
if(combined){
var cp=priceAndInput(combined);
if(cp&&cp.input){
cp.input.disabled=qualified;
if(qualified)cp.input.checked=false;
if(cp.price)cp.price.textContent=qualified?'Priority already free':combo;
if(cp.description)cp.description.textContent=qualified?'First in Line is free at '+(isUS?'$98':'£75')+'. Add Express delivery for '+ex+' from your basket.':'Priority artwork preparation, then express courier delivery after printing.';
combined.classList.toggle('pg-extras__card--pending-v146',qualified);
}}
var express=document.querySelector('[data-pg-extras] [data-pg-express-only-v146]');
if(express){var ep=priceAndInput(express);if(ep&&ep.input){ep.input.checked=false;ep.input.disabled=true;}}
var matching=document.querySelector('[data-pg-matching-digital-v146]');
if(matching){
var mp=priceAndInput(matching);
var eligible=engine&&typeof engine.eligibleArtworkLines==='function'?engine.eligibleArtworkLines(c):[];
var included=qualified&&eligible.length>0;
var already=(c.items||[]).some(function(line){return [67690278158588,51223262560508].includes(Number(line.variant_id));});
if(mp&&mp.input){
mp.input.disabled=!!(included||already);
if(included||already)mp.input.checked=false;
mp.input.setAttribute('aria-label',included?'Digital artwork included free in this basket':already?'Matching digital copy already added':'Add matching digital copy for '+(isUS?'$15':'£9.99'));
}
if(mp&&mp.price)mp.price.textContent=included?'FREE · included':already?'Already in basket':dig;
matching.classList.toggle('pg-extras__card--included-v146',!!included);
matching.classList.toggle('pg-extras__card--already-v147',!!already&&!included);
}
}
function fetchCart(){
var sequence=++fetchSequence;
fetch(root()+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
.then(function(response){if(!response.ok)throw Error('Cart read failed');return response.json()})
.then(function(cart){if(sequence===fetchSequence){cache=cart;apply(cart)}})
.catch(function(){});
}
function refresh(){if(cache)apply(cache);fetchCart()}
function start(){
var express=document.querySelector('[data-pg-extras] [data-pg-express-only-v146] .pg-extras__check');
if(express){express.disabled=true;express.checked=false;}
refresh();
document.addEventListener('pg:cart-synchronised',function(event){if(event&&event.detail&&event.detail.cart){fetchSequence++;cache=event.detail.cart;apply(cache)}});
document.addEventListener('cart:refresh',refresh);
document.addEventListener('shopify:section:load',refresh);
window.addEventListener('pageshow',refresh);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();